import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-import-icon',
  templateUrl: './files-import.component.html'
})
export class FilesImportComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
